<template>
  <InputComponent
    :icon="['fal', 'search']"
    icon-placement="right"
    :label="$t('search')"
    :placeholder="placeholder"
    :title="`${$t('searchFor')} ${placeholder}`"
    :value="value"
    @input="$ev => $emit('input', $ev)"
    type="search"
  />
</template>

<script>
import { InputComponent } from 'vue-elder-input'

export default {
  props: ['value', 'options'],
  computed: {
    placeholder() {
      return (
        this.$path('options.placeholder') ||
        [this.$t('name'), this.$t('email'), this.$tc('tag', 2)].map((v, i) => (i ? v.toLowerCase() : v)).join(', ')
      )
    },
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss"></style>
